import gql from 'graphql-tag';

export default gql`
  mutation createMessage(
    $id: ID!
    $content: String
    $conversationId: ID!
    $createdAt: String!
    $hasFiles: Boolean
    $messageType: Int
    $sender: String
    $senderInfo: SenderInfoInput
  ) {
    createMessage(
      id: $id
      content: $content
      conversationId: $conversationId
      createdAt: $createdAt
      hasFiles: $hasFiles
      messageType: $messageType
      sender: $sender
      senderInfo: $senderInfo
    ) {
      __typename
      conversationId
      createdAt
      id
      sender
      senderInfo {
        name
        email
      }
      content
      isSent
      hasFiles
      messageType
    }
  }
`;
